var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gs-wizard-step',[_c('p-row',[_c('p-col',{attrs:{"xs12":"","lg6":""}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('memberPortal.linkMembership.label.confirmationText'))+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }